<footer>
  <div class="logo">
    <a href="/">
      <img
        class="mini-logo-img"
        src="assets/images/mini-logo.png"
        height="50px"
        width="85px"
        alt="Logo"
      />
    </a>

    <div class="tagline">
      <span class="section-heading">Think Supply,</span>
      <span class="section-heading">Think ZippMat<sup>&#9415;</sup></span>
    </div>
  </div>
</footer>
